export const formatDate = (date: Date) => {
  const dateCopy = new Date(date);
  // Wir lassen keine Sekunden setzen und wollen ein einheitliches Bild im UI
  dateCopy.setSeconds(0);
  return dateCopy.toLocaleString("de-DE");
};
